export default __webpack_public_path__ + "static/media/BikeRed.ba3676cc.png";